import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import React from "react"
import { Modal, Pressable, TouchableOpacity, View } from "react-native"

export const DialogModal = ({
    visible,
    onDismiss,
    title,
    confirmText = "Oui",
    cancelText = "Annuler",
    onConfirm,
    confirmColor = theme.colors.error,
    dismissable = true,
}) => {
    const handleConfirm = () => {
        onDismiss?.()
        onConfirm?.()
    }

    return (
        <Modal
            visible={visible}
            transparent
            animationType="fade"
            onRequestClose={onDismiss}
        >
            <Pressable
                style={{
                    flex: 1,
                    backgroundColor: "rgba(0,0,0,0.5)",
                    justifyContent: "center",
                    alignItems: "center",
                }}
                onPress={dismissable ? onDismiss : undefined}
            >
                <View
                    style={{
                        backgroundColor: theme.colors.white,
                        borderRadius: 20,
                        padding: 24,
                        minWidth: 280,
                        alignItems: "center",
                    }}
                >
                    <TextM
                        fontSize={16}
                        fontWeight="Bold"
                        style={{ marginBottom: 24, textAlign: "center" }}
                    >
                        {title}
                    </TextM>
                    <View
                        style={{
                            flexDirection: "row",
                            marginHorizontal: -6,
                        }}
                    >
                        <TouchableOpacity
                            onPress={onDismiss}
                            style={{
                                paddingVertical: 10,
                                paddingHorizontal: 20,
                                borderRadius: theme.roundness,
                                marginHorizontal: 6,
                            }}
                        >
                            <TextM
                                color={theme.colors.primary}
                                fontWeight="Bold"
                            >
                                {cancelText}
                            </TextM>
                        </TouchableOpacity>
                        <TouchableOpacity
                            onPress={handleConfirm}
                            style={{
                                paddingVertical: 10,
                                paddingHorizontal: 20,
                                borderRadius: theme.roundness,
                                backgroundColor: confirmColor,
                                marginHorizontal: 6,
                            }}
                        >
                            <TextM color={theme.colors.white} fontWeight="Bold">
                                {confirmText}
                            </TextM>
                        </TouchableOpacity>
                    </View>
                </View>
            </Pressable>
        </Modal>
    )
}
